import el from "@cypherpotato/el";
import { Image } from "./image";

const ModelSourceUrl = model => model.startsWith('@') ?
    `/assets/providers/${model.split('/')[0].replace('@', '')}.svg` :
    `/assets/providers/${model}.svg`;

export function ModelBadge(modelName, ...args) {

    var modelNameObject;

    if (modelName.startsWith('@') && modelName.includes('/')) {

        var parts = modelName.split('/');
        modelNameObject = el.fragment(
            el("span.model-provider", parts[0], "/"),
            el("span.model-name", parts[1])
        );

    } else {
        modelNameObject = el("span.model-name", modelName);
    }


    return el(".model-badge",
        Image(ModelSourceUrl(modelName), { classList: "bg1" }),
        Image(ModelSourceUrl(modelName), { classList: "bg2" }),
        ModelIcon(modelName),
        el(".model-name-wrapper",
            modelNameObject
        ),
        ...args
    )
}

export function ProviderBadge(providerName, ...args) {
    const [, name, suffix] = providerName.replace(/:offline$/, "").match(/^(.*?)\s*(\(.*\))?$/);
    const src = `/assets/providers/${name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}.svg`;

    return el(".model-badge",
        Image(src, { classList: "bg1" }),
        Image(src, { classList: "bg2" }),
        Image(src, {
            alt: "",
            onError() {
                this.src = "/assets/providers/unknown.svg";
            }
        }),
        el(".model-name-wrapper",
            el("span.model-name", name),
            suffix && el("span.model-provider", " ", suffix)
        ),
        ...args
    )
}

export function ModelIcon(model, ...args) {
    const src = ModelSourceUrl(model);

    return Image(src, {
        onError() {
            this.src = "/assets/providers/unknown.svg";
        },
    }, args);
}
